import galleryManifest from "../data/galleryManifest.json";

/** public/assets altındaki klasör adları (şube slug ile aynı). */
export const BRANCH_GALLERY_PUBLIC_FOLDER = {
  caddebostan: "caddebostan",
  zeytinburnu: "zeytinburnu",
};

export function branchGalleryAssetPath(branch, filename) {
  const folder = BRANCH_GALLERY_PUBLIC_FOLDER[branch] || branch;
  return `/assets/${folder}/${filename}`;
}

/**
 * Manifestteki sıralı listeden 1-based indeks (ör. ana sayfa 4. görsel = 4).
 * Liste yoksa veya kısaysa caddeN / zeytinN.jpeg yedekleri kullanılır.
 */
export function branchGalleryUrl(branch, index1Based) {
  const folder = BRANCH_GALLERY_PUBLIC_FOLDER[branch] || branch;
  const files = galleryManifest[branch];
  if (files?.length) {
    const idx = Math.min(Math.max(index1Based, 1), files.length) - 1;
    return `/assets/${folder}/${files[idx]}`;
  }
  const prefix = branch === "caddebostan" ? "cadde" : "zeytin";
  return `/assets/${folder}/${prefix}${index1Based}.jpeg`;
}
